export default __webpack_public_path__ + "static/8-0d7199f943bf45a2bcb9e84f95172eaa.jpg";